<template>
    <div class="">
        <b-modal
            v-if="openInModal"
            v-show="showForm"
            id="add_addressModal"
            :hideFooter="true"
            :title="title"
            ref="addressModal"
            size="md"
        >
            <form-address
                ref="addressForm"
                :id="addressId"
                @addressStored="addAddress"
                @addressUpdated="updateAddress"
            />
        </b-modal>

        <form-address v-else v-show="showForm" ref="addressForm" @addressStored="addAddress" :location="false"></form-address>

        <div class="col-12 list-holder">
            <a href="#"
                class="btn btn-brand"
                @click.prevent="createAddress"
            >
                {{ uLang('app.add_type', { type: this.uLang('app.address') }) }}
            </a>

            <div class="row mt-3">
                <div class="col-md-4" v-for="address in addresses">
                    <address-card
                        :address="address"
                        :deleteAddress="removeAddress"
                        :editAddress="editAddress"
                        :duplicateAddress="duplicateAddress"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { ConfirmationAlert } from "~/Swals";

    export default {
        name: "module-address",

        props: {
            title: {
                type: String,
                default: ''
            },
            openInModal: {
                type: Boolean,
                default: true,
            }
        },

        data(){
            return {
                addresses: [],
                addressId: null,
                showForm: false,
            };
        },

        methods: {
            clear() {
                this.addresses = [];
            },

            duplicateAddress(address) {
                new ConfirmationAlert({
                    text: this.uLang('app.duplicate_type', { type: this.lang('app.address') })
                })
                    .show()
                    .then(async () => {
                        const { data } = await window.axios.post(route('addresses.duplicate', {
                            address: address.id
                        }));

                        this.addAddress(data);
                    })
            },

            createAddress() {
                this.showForm = true;

                this.$nextTick(() => {
                    this.$refs.addressForm.form.reset();
                    this.openInModal && this.$refs.addressModal.show();
                })
            },

            addAddress(address) {
                this.openInModal && this.$refs.addressModal.hide();

                this.$nextTick(() => {
                    this.showForm = false;
                    this.addresses.push(address);
                    this.$emit('addressesUpdated', this.addresses)
                })
            },

            editAddress(address) {
                this.modalTitle = this.uLang('app.edit_type', { type: this.lang('app.address')});
                this.addressId = address.id;

                this.showForm = true;

                this.$nextTick(() => {
                    this.$refs.addressForm.retrieve();
                    this.openInModal && this.$refs.addressModal.show();
                });
            },

            updateAddress(updatedAddress) {
                this.openInModal && this.$refs.addressModal.hide();

                this.addresses = this.addresses.map((address) => {
                    if(address.id === updatedAddress.id) {
                        return updatedAddress;
                    }

                    return address;
                });

                this.$emit('addressesUpdated', this.addresses);
            },

            removeAddress(address){
                this.addresses = this.addresses.filter(function (current_address) {
                    return address.id != current_address.id;
                });

                this.addressId = null;

                this.$emit('addressesUpdated', this.addresses)
            },
        }
    }
</script>
<!-- styles -->
<!-- adding scoped attribute will apply the css to this component only -->
<style scoped>
    .remove-address {
        margin-right: 20px;
    }
</style>
